export default "__VITE_ASSET__CWLSHcq1__"